import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { cloudFunctionsInstance } from 'config/axios'
import { toast } from 'utils/notify'

const useValidateSpeakerToken = () => {
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [refetch, setRefetch] = useState(false)
  // get token and type fro query params
  const token = new URLSearchParams(location.search).get('token')

  const [apiResponse, setApiResponse] = useState(null)

  const getSpeakerByToken = async () => {
    try {
      setLoading(true)
      const response = await cloudFunctionsInstance.get(`/getSpeakerByToken?token=${token}`)
      setApiResponse(response.data)
    } catch (err) {
      toast.error(
        err?.response?.data?.msg || 'Something went wrong when fetching the data. Please try again.'
      )
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getSpeakerByToken()
  }, [])

  useEffect(() => {
    if (refetch && token) {
      getSpeakerByToken()
    }
  }, [token, refetch])

  return {
    isLoading: loading,
    isTokenValid: !!apiResponse?.conference?.id,
    speaker: apiResponse?.speaker ?? null,
    conference: apiResponse?.conference ?? null,
    refetch: () => setRefetch(true)
  }
}

export default useValidateSpeakerToken
